import React from "react";
//#region types
import { DrillDownTableBodyProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import DrillDownTableRow from "./rows/row";
import { TableBody } from "@mui/material";
import DrillDownTableEmptyRow from "./rows/emptyRow";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const DrillDownTableBody = <RowType extends Record<string, any>, T extends Record<string, any>>(
  props: React.PropsWithChildren<DrillDownTableBodyProps<RowType, T>>
) => {
  const { rows, repeatProperties, hiddenColumns, rowTextProperty, repeatColumnLength } = props;

  const repeatPropertiesLength = repeatProperties?.properties ? Object.entries(repeatProperties.properties).length : 0;

  const repeatPropertiesList =
    repeatProperties &&
    Object.entries(repeatProperties.properties).filter(([repeatKey]) => !hiddenColumns?.some((hc) => hc === repeatKey));

  return (
    <TableBody className={cssExports.tableBody}>
      {/* Add spacing at the top of the table before the content */}
      <DrillDownTableEmptyRow
        repeatPropertiesList={repeatPropertiesList}
        repeatPropertiesLength={repeatPropertiesLength}
        repeatColumnLength={repeatColumnLength}
        className={cssExports.spacingRow}
        showTotal={!!props.showTotal}
      />
      {rows.length > 0 &&
        rows.map((row, index) => (
          <DrillDownTableRow
            key={`tab-row-${0}-${index}`}
            row={row}
            index={index}
            parentIndex={-1}
            path={[]}
            depth={0}
            childrenKey={props.childrenKey}
            rowTextProperty={rowTextProperty}
            repeatPropertyKey={repeatProperties?.key.toString()}
            repeatPropertiesList={repeatPropertiesList}
            repeatPropertiesLength={repeatPropertiesLength}
            repeatColumnLength={repeatColumnLength}
            rowDisplayType={props.rowDisplayType}
            showTotal={props.showTotal}
            sumNegative={repeatProperties?.sumNegative}
            autoExpandProps={props.autoExpandProps}
          />
        ))}

      {/* Add spacing at the bottom of the table */}
      <DrillDownTableEmptyRow
        repeatPropertiesList={repeatPropertiesList}
        repeatPropertiesLength={repeatPropertiesLength}
        repeatColumnLength={repeatColumnLength}
        className={cssExports.spacingRow}
        showTotal={!!props.showTotal}
      />
    </TableBody>
  );
};

export default DrillDownTableBody;
